var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM10.5844 10.6594L9.55313 10.6547L8 8.80313L6.44844 10.6531L5.41563 10.6578C5.34688 10.6578 5.29063 10.6031 5.29063 10.5328C5.29063 10.5031 5.30156 10.475 5.32031 10.4516L7.35313 8.02969L5.32031 5.60938C5.30143 5.58647 5.29096 5.5578 5.29063 5.52812C5.29063 5.45937 5.34688 5.40312 5.41563 5.40312L6.44844 5.40781L8 7.25938L9.55156 5.40938L10.5828 5.40469C10.6516 5.40469 10.7078 5.45937 10.7078 5.52969C10.7078 5.55937 10.6969 5.5875 10.6781 5.61094L8.64844 8.03125L10.6797 10.4531C10.6984 10.4766 10.7094 10.5047 10.7094 10.5344C10.7094 10.6031 10.6531 10.6594 10.5844 10.6594Z",
    fill: "#FF4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5843 10.6593L9.55303 10.6546L7.9999 8.80308L6.44834 10.6531L5.41553 10.6578C5.34678 10.6578 5.29053 10.6031 5.29053 10.5328C5.29053 10.5031 5.30146 10.475 5.32021 10.4515L7.35303 8.02964L5.32021 5.60933C5.30133 5.58643 5.29086 5.55775 5.29053 5.52808C5.29053 5.45933 5.34678 5.40308 5.41553 5.40308L6.44834 5.40776L7.9999 7.25933L9.55146 5.40933L10.5827 5.40464C10.6515 5.40464 10.7077 5.45933 10.7077 5.52964C10.7077 5.55933 10.6968 5.58745 10.678 5.61089L8.64834 8.0312L10.6796 10.4531C10.6983 10.4765 10.7093 10.5046 10.7093 10.5343C10.7093 10.6031 10.653 10.6593 10.5843 10.6593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d9939112eee51feb0e207e055675f901.svg";
export { ForwardRef as ReactComponent };